import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CatalogoIndicadoresService {

  constructor() { }

  catalogoTipoDocumento() {
    return [
      { clave: 1, valor: 'CANAL MODERNO' },
      { clave: 2, valor: 'CANAL TRADICIONAL' }
    ]
  }

  catalogoOpciones() {
    return [
      { clave: 1, valor: 'SI' },
      { clave: 0, valor: 'NO' }
    ]
  }

  catalogoAnio() {
    let anioIni = 2021;
    let anioFin = new Date().getFullYear();
    let cmb = [];
    for (let index = anioIni; index <= anioFin; index++) {
      cmb.push( { clave: index, valor: index });
    }
    return cmb;
    // return [
    //   { clave: 2021, valor: '2021' },
    //   { clave: 2022, valor: '2022' }
    // ]
  }

  catalogoMeses() {
    return [
      { clave: 1, valor: 'Enero' },
      { clave: 2, valor: 'Febrero' },
      { clave: 3, valor: 'Marzo' },
      { clave: 4, valor: 'Abril' },
      { clave: 5, valor: 'Mayo' },
      { clave: 6, valor: 'Junio' },
      { clave: 7, valor: 'Julio' },
      { clave: 8, valor: 'Agosto' },
      { clave: 9, valor: 'Septiembre' },
      { clave: 10, valor: 'Octubre' },
      { clave: 11, valor: 'Noviembre' },
      { clave: 12, valor: 'Diciembre' },
    ]
  }
}
